export { bodyBold } from "./BodyBoldText.styles";
export { BodyBoldText } from "./BodyBoldText";
